import { useCallback, useEffect, useState } from "react";
import { useLatestRequest } from "../../../hooks/useLatestRequest";
import { getPublicAlertTypeOptions, PublicOptionResponse } from "./publicOptions.api";

interface UseGetAlertTypeOptionsReturn {
  alertTypes: PublicOptionResponse[];
  loading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

export const useGetAlertTypeOptions = (): UseGetAlertTypeOptionsReturn => {
  const [alertTypes, setAlertTypes] = useState<PublicOptionResponse[]>([]);
  const [error, setError] = useState<string | null>(null);
  const { run: runLatestRequest, loading } = useLatestRequest();

  const fetchAlertTypeOptions = useCallback(async () => {
    try {
      setError(null);
      const response = await runLatestRequest(getPublicAlertTypeOptions);
      if (!response) return;
      setAlertTypes(response);
    } catch (error) {
      console.error("Failed to fetch alert type options:", error);
      setError("Failed to fetch alert type options");
    }
  }, [runLatestRequest]);

  useEffect(() => {
    void fetchAlertTypeOptions();
  }, [fetchAlertTypeOptions]);

  return {
    alertTypes,
    loading,
    error,
    refetch: fetchAlertTypeOptions,
  };
};
